<template>
  <VPopupWidget
    :name="computedTitle"
    :icon="$vuetify.icons.values.add"
    :visible="menu"
    :set-expand="
      (v) => {
        menu = v
      }
    "
    btnDepressed
    btnColor="default"
    bottom
    left
  >
    <template slot="title">{{ $t('title') }}</template>

    <template slot="content" v-if="added">
      <h3>{{ $t('successTitle') }}</h3>
    </template>
    <template slot="content" v-else>
      <FormErrors :show="showResourceErrors" :errors="resourceErrors" />
      <UserField v-model="userId" :errors="selectionErrors" :provided="providedUsers" />
      <AttributionField v-model="selectedAttribution" :errors="attributionErrors" v-if="editableAttribution" />
    </template>

    <template slot="footer-actions">
      <v-btn depressed v-if="!added" @click="submit">{{ $t('add') }}</v-btn>
      <v-btn depressed v-if="added" @click="added = false">{{ $t('addMore') }}</v-btn>
    </template>
  </VPopupWidget>
</template>

<script>
import { find } from 'lodash/collection'
import { required } from 'vuelidate/lib/validators'
import UserField from './UserField'
import AttributionField from './AttributionField'
import { VPopupWidget, BaseForm, FormErrors } from '@argon/app/components'

export default {
  name: 'AddUserAttribution',
  extends: BaseForm,
  components: {
    VPopupWidget,
    FormErrors,
    UserField,
    AttributionField
  },
  props: {
    multiple: { type: Boolean, default: false },
    handleSubmit: { type: Function, required: true },
    defaultAttribution: { type: Number, default: 20 },
    editableAttribution: { type: Boolean, default: true },
    providedUsers: Array,
    attributionPool: Array,
    isIconBtn: { type: Boolean, default: false }
  },
  validations: {
    selectedAttribution: { required },
    userId: { required }
  },
  data: () => ({
    search: null,
    userId: null,
    selectedAttribution: null,
    added: false,
    menu: false,
    loading: false
  }),
  computed: {
    attributionErrors() {
      const errors = []
      this.getServerErrors('attribution', errors)
      if (!this.$v.selectedAttribution.$dirty) return errors
      !this.$v.selectedAttribution.required && errors.push(this.$t('required'))
      return errors
    },
    selectionErrors() {
      const errors = []
      if (!this.$v.userId.$dirty) return errors
      !this.$v.userId.required && errors.push(this.$t('required'))
      return errors
    },
    computedTitle() {
      if (!this.isIconBtn) {
        return this.$t('title')
      } else {
        return null
      }
    }
  },
  watch: {
    userId: function (v) {
      if (this.attributionPool) {
        let match = find(this.attributionPool, { principal_id: v })
        if (match) {
          this.selectedAttribution = match.attribution
        }
      }
    }
  },
  methods: {
    updateSelection(value) {
      this.userId = value
    },
    submit() {
      this.resetServerErrors()
      if (this.$v.selectedAttribution.$invalid || !this.userId) {
        this.$v.selectedAttribution.$touch()
        this.$v.userId.$touch()
        return
      }
      this.loading = true
      this.handleSubmit({
        principalIds: [this.userId],
        attribution: this.selectedAttribution
      })
        .then(() => {
          this.userId = null
          this.selectedAttribution = this.defaultAttribution
          this.menu = false
          this.$v.$reset()
        })
        .catch(this.setServerErrors)
        .finally(() => {
          this.loading = false
        })
    }
  },
  created() {
    this.resetServerErrors()
    this.selectedAttribution = this.defaultAttribution
  }
}
</script>

<i18n>
{
  "en": {
    "add": "@:labels.add",
    "addMore": "@:labels.addMore",
    "attributionLabel": "Attribution",
    "required": "@:labels.required",
    "successTitle": "Successfully Added",
    "title": "Add User"
  },
  "fr": {
    "add": "@:labels.add",
    "addMore": "@:labels.addMore",
    "attributionLabel": "Attribution",
    "required": "@:labels.required",
    "successTitle": "Ajouté avec succès",
    "title": "Ajouter un utilisateur"
  }
}
</i18n>
